"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importStar(require("react"));
var ts_utils_1 = require("../../../misc/ts-utils");
var horizontal_drag_scroll_1 = __importDefault(require("../../shared-components/horizontal-drag-scroll"));
var progress_bar_1 = __importDefault(require("../../shared-components/progress-bar"));
var quantity_picker_1 = __importDefault(require("../components/quantity-picker"));
var bundle_1 = require("../store/bundle");
var scrolling_1 = require("../utils/scrolling");
var ProductCard = function (_a) {
    var _b;
    var className = _a.className, imageContainerClassName = _a.imageContainerClassName, item = _a.item, selected = _a.selected, quantity = _a.quantity, onIncrement = _a.onIncrement, onDecrement = _a.onDecrement, width = _a.width;
    var approximateQuantityPickerHeight = 34;
    return (
    // bottom padding is a dirty little attempt to contain our negative-margin Quantity Picker within the bounds of this element
    react_1.default.createElement("div", { className: className, style: { width: width, userSelect: 'none', paddingBottom: approximateQuantityPickerHeight / 2 } },
        react_1.default.createElement("div", { className: 'height-100', style: { display: 'grid', gridTemplateRows: 'min-content', gridTemplateColumns: '1fr' } },
            react_1.default.createElement("div", { className: 'flex-container align-bottom', style: { gridArea: '1 / 1 / 2 / 2' } },
                react_1.default.createElement("div", { style: { width: '100%', marginBottom: -approximateQuantityPickerHeight / 2 + 1 } },
                    react_1.default.createElement("div", { className: 'flex-container align-center position-relative' },
                        react_1.default.createElement("div", { style: { width: '70%' } },
                            react_1.default.createElement(quantity_picker_1.default, { quantity: quantity, increase: onIncrement, decrease: onDecrement }))))),
            react_1.default.createElement("div", { className: (0, classnames_1.default)(imageContainerClassName, 'rounded-lg overflow-hidden', selected ? 'border-wisteria' : 'border-brownish-grey'), style: { gridArea: '1 / 1 / 2 / 2', height: width, aspectRatio: width ? undefined : '1/1', borderWidth: selected ? 3 : 1, borderStyle: 'solid' }, onClick: onIncrement }, ((_b = item.variant.featuredImage) === null || _b === void 0 ? void 0 : _b.src) && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("img", { className: 'height-100 width-100 object-fit-cover', src: item.variant.featuredImage.src, alt: item.variant.featuredImage.alt, draggable: false, style: { pointerEvents: 'none', userSelect: 'none' } })))))));
};
/** map Sizes to tab names */
var tabNameMap = {
    diaper_n: 'Size N',
    diaper_1: 'Size 1',
    diaper_2: 'Size 2',
    diaper_3: 'Size 3',
    diaper_4: 'Size 4',
    diaper_5: 'Size 5',
    diaper_6: 'Size 6',
    training_12_24: 'Size 12-24M',
    training_2t_3t: 'Size 2T-3T',
    training_3t_4t: 'Size 3T-4T',
    training_4t_5t: 'Size 4T-5T',
};
var SizeTabs = function (_a) {
    var tab = _a.tab, setTabSize = _a.setTabSize, tabs = _a.tabs;
    var displayTabs = tabs.map(function (t) { return ({ size: t.size, color: t.color, active: t.size === tab, displayName: tabNameMap[t.size] }); });
    // TODO: consider adding an animation where the selected tab slides from one to the other when it changes
    return (react_1.default.createElement(react_1.default.Fragment, null, displayTabs.map(function (option) { return (react_1.default.createElement("div", { key: option.displayName, className: (0, classnames_1.default)('text-base flex-container align-center cursor-pointer rounded-base padding-vertical-2'), style: { fontWeight: 500, flex: '1', backgroundColor: option.active ? option.color : undefined }, onClick: function () { return setTabSize(option.size); } }, option.displayName)); })));
};
var buildSelectedPatternsPerSize = function (flatPatternsPerSize, selectedPatterns) {
    var e_1, _a, e_2, _b, e_3, _c;
    var result = {};
    try {
        // initialize a category for each size
        for (var _d = __values((0, ts_utils_1.entries)(flatPatternsPerSize)), _e = _d.next(); !_e.done; _e = _d.next()) {
            var _f = __read(_e.value, 1), size = _f[0];
            result[size] = { displayName: 'Your Selections', displayType: 'horizontalScroll', patterns: [] };
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
        }
        finally { if (e_1) throw e_1.error; }
    }
    try {
        for (var _g = __values((0, ts_utils_1.entries)(flatPatternsPerSize)), _h = _g.next(); !_h.done; _h = _g.next()) {
            var _j = __read(_h.value, 2), size = _j[0], patterns = _j[1];
            if (!patterns)
                throw new Error('Coding bug: patterns is falsy when generating selectedPatternsPerSize');
            var variantIdsThisSize = patterns.map(function (pattern) { return pattern.id; });
            try {
                for (var selectedPatterns_1 = (e_3 = void 0, __values(selectedPatterns)), selectedPatterns_1_1 = selectedPatterns_1.next(); !selectedPatterns_1_1.done; selectedPatterns_1_1 = selectedPatterns_1.next()) {
                    var selectedPattern = selectedPatterns_1_1.value;
                    if (variantIdsThisSize.includes(selectedPattern.variant.id)) {
                        var category = result[size];
                        if (!category)
                            throw new Error('Coding bug: category not initialized when generating selectedPatternsPerSize');
                        category.patterns.push(selectedPattern);
                    }
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (selectedPatterns_1_1 && !selectedPatterns_1_1.done && (_c = selectedPatterns_1.return)) _c.call(selectedPatterns_1);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    }
    catch (e_2_1) { e_2 = { error: e_2_1 }; }
    finally {
        try {
            if (_h && !_h.done && (_b = _g.return)) _b.call(_g);
        }
        finally { if (e_2) throw e_2.error; }
    }
    return result;
};
/**
 * Attempt to increase the selected quantity of this pattern, or add the pattern if this is the first selection of it.
 * The bundle store will quietly prevent us from adding too many of a size, so we don't perform that check here.
 * However, we do check if the user has filled up their `validPatternQuantity` with only one size and prevent them from
 * doing that.
 */
var onIncrementPatternQuantity = function (variant, existingSelectedPatterns, changePatterns, flatPatternsPerSize, tab, validPatternQuantity, selectedSizes) {
    var e_4, _a;
    // deep clone quantity so that we can modify quantity
    var newPatterns = existingSelectedPatterns.map(function (pattern) { return ({ variant: pattern.variant, quantity: pattern.quantity }); });
    // first try to increment the quantity if we already have this pattern
    var updatedExisting = false;
    try {
        for (var newPatterns_1 = __values(newPatterns), newPatterns_1_1 = newPatterns_1.next(); !newPatterns_1_1.done; newPatterns_1_1 = newPatterns_1.next()) {
            var pattern = newPatterns_1_1.value;
            if (variant.id === pattern.variant.id) {
                pattern.quantity += 1;
                updatedExisting = true;
            }
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (newPatterns_1_1 && !newPatterns_1_1.done && (_a = newPatterns_1.return)) _a.call(newPatterns_1);
        }
        finally { if (e_4) throw e_4.error; }
    }
    // if we didn't have this pattern selected yet, add it
    if (!updatedExisting) {
        newPatterns.push({ variant: variant, quantity: 1 });
    }
    // Is the user trying to purchase a mixed/multi bundle but has already already selected the maximum number of patterns in one size such
    // that they won't be able to select any in their second size? If so, alert the user and refuse to add the new pattern.
    if (selectedSizes.length > 1) {
        var selectedPatternsPerSize = buildSelectedPatternsPerSize(flatPatternsPerSize, newPatterns);
        var currentTabPatterns = selectedPatternsPerSize === null || selectedPatternsPerSize === void 0 ? void 0 : selectedPatternsPerSize[tab];
        var quantitySelectedInCurrentTab = currentTabPatterns === null || currentTabPatterns === void 0 ? void 0 : currentTabPatterns.patterns.reduce(function (total, pattern) { return total + pattern.quantity; }, 0);
        if (quantitySelectedInCurrentTab !== undefined && quantitySelectedInCurrentTab >= validPatternQuantity) {
            var otherSize = selectedSizes.find(function (size) { return size !== tab; });
            if (!otherSize)
                throw new Error('Coding bug: otherSize is undefined'); // we already know that there is more than one selected size
            var currentTab = tabNameMap[tab];
            var otherTab = tabNameMap[otherSize];
            alert("You've only selected designs for ".concat(currentTab, ". Toggle to ").concat(otherTab, " to complete your selections."));
            return;
        }
    }
    changePatterns(newPatterns);
};
var onDecrementPatternQuantity = function (variant, existingSelectedPatterns, changePatterns) {
    var e_5, _a;
    // deep clone quantity so that we can modify quantity
    var newPatterns = existingSelectedPatterns.map(function (pattern) { return ({ variant: pattern.variant, quantity: pattern.quantity }); });
    try {
        // decrement quantity of the given pattern
        for (var newPatterns_2 = __values(newPatterns), newPatterns_2_1 = newPatterns_2.next(); !newPatterns_2_1.done; newPatterns_2_1 = newPatterns_2.next()) {
            var pattern = newPatterns_2_1.value;
            if (variant.id === pattern.variant.id) {
                pattern.quantity -= 1;
                // if we now have 0 quantity of this pattern, just remove it
                if (pattern.quantity === 0) {
                    newPatterns = newPatterns.filter(function (p) { return p.variant.id !== variant.id; });
                }
                changePatterns(newPatterns);
                return;
            }
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (newPatterns_2_1 && !newPatterns_2_1.done && (_a = newPatterns_2.return)) _a.call(newPatterns_2);
        }
        finally { if (e_5) throw e_5.error; }
    }
};
/** Build an event with the same shape and values as what the v1 diaper bundler emits */
var buildArrivedAtStepEvent = function (selectedSizes) {
    var e_6, _a;
    var selSizeQuantities = [];
    var _loop_1 = function (selectedSize) {
        var size = (function () {
            switch (selectedSize) {
                case 'diaper_n':
                    return { size: 'N', productType: 'Diapers' };
                case 'diaper_1':
                    return { size: '1', productType: 'Diapers' };
                case 'diaper_2':
                    return { size: '2', productType: 'Diapers' };
                case 'diaper_3':
                    return { size: '3', productType: 'Diapers' };
                case 'diaper_4':
                    return { size: '4', productType: 'Diapers' };
                case 'diaper_5':
                    return { size: '5', productType: 'Diapers' };
                case 'diaper_6':
                    return { size: '6', productType: 'Diapers' };
                case 'training_12_24':
                    return { size: '12-24M', productType: 'TrainingPants' };
                case 'training_2t_3t':
                    return { size: '2T-3T', productType: 'TrainingPants' };
                case 'training_3t_4t':
                    return { size: '3T-4T', productType: 'TrainingPants' };
                case 'training_4t_5t':
                    return { size: '4T-5T', productType: 'TrainingPants' };
            }
        })();
        selSizeQuantities.push(size);
    };
    try {
        for (var selectedSizes_1 = __values(selectedSizes), selectedSizes_1_1 = selectedSizes_1.next(); !selectedSizes_1_1.done; selectedSizes_1_1 = selectedSizes_1.next()) {
            var selectedSize = selectedSizes_1_1.value;
            _loop_1(selectedSize);
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (selectedSizes_1_1 && !selectedSizes_1_1.done && (_a = selectedSizes_1.return)) _a.call(selectedSizes_1);
        }
        finally { if (e_6) throw e_6.error; }
    }
    var event = { event: 'diaperBundle__prints', sizes: selSizeQuantities };
    return event;
};
var Patterns = function (_a) {
    var e_7, _b, e_8, _c;
    var navBar = _a.navBar;
    var useBundleStore = (0, bundle_1.getBundleStore)().useBundleStore;
    var validPatternGroups = useBundleStore(function (state) { return state.validPatternGroups; });
    var preferredPatternGender = useBundleStore(function (state) { return state.preferredPatternGender; });
    var patternStepHeader = useBundleStore(function (state) { return state.patternStepHeader; });
    var selectedPatterns = useBundleStore(function (state) { return state.selectedPatterns; });
    var changePatterns = useBundleStore(function (state) { return state.changeSelectedPatterns; });
    var validPatternQuantity = useBundleStore(function (state) { return state.validPatternQuantity; });
    var selectedSizes = validPatternGroups.map(function (group) { return group.size; });
    var _d = __read((0, react_1.useState)(selectedSizes[0]), 2), tab = _d[0], setTab = _d[1];
    // Instantly scroll to top. This is necessary because we share the page's scrollbar between all of the steps
    // and we want the user to start at the top of each step.
    var hasPerformedInitialScrollToTop = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        if (!hasPerformedInitialScrollToTop.current) {
            (0, scrolling_1.performInstantScroll)(window, { top: 0 });
            hasPerformedInitialScrollToTop.current = true;
        }
    });
    // Analytics.
    var hasEmittedDataLayerEvent = (0, react_1.useRef)(false);
    (0, react_1.useEffect)(function () {
        var _a;
        if (!hasEmittedDataLayerEvent.current) {
            (_a = window.dataLayer) === null || _a === void 0 ? void 0 : _a.push(buildArrivedAtStepEvent(selectedSizes));
            hasEmittedDataLayerEvent.current = true;
        }
    });
    // Build a flat set of variants per size.
    var flatPatternsPerSize = (function () {
        var e_9, _a, e_10, _b, e_11, _c, e_12, _d;
        var _e, _f;
        // initialize a patternVariants array for each size
        var result = {};
        try {
            for (var validPatternGroups_1 = __values(validPatternGroups), validPatternGroups_1_1 = validPatternGroups_1.next(); !validPatternGroups_1_1.done; validPatternGroups_1_1 = validPatternGroups_1.next()) {
                var size = validPatternGroups_1_1.value.size;
                result[size] = [];
            }
        }
        catch (e_9_1) { e_9 = { error: e_9_1 }; }
        finally {
            try {
                if (validPatternGroups_1_1 && !validPatternGroups_1_1.done && (_a = validPatternGroups_1.return)) _a.call(validPatternGroups_1);
            }
            finally { if (e_9) throw e_9.error; }
        }
        try {
            for (var validPatternGroups_2 = __values(validPatternGroups), validPatternGroups_2_1 = validPatternGroups_2.next(); !validPatternGroups_2_1.done; validPatternGroups_2_1 = validPatternGroups_2.next()) {
                var _g = validPatternGroups_2_1.value, size = _g.size, groups_2 = _g.groups;
                try {
                    for (var groups_1 = (e_11 = void 0, __values(groups_2)), groups_1_1 = groups_1.next(); !groups_1_1.done; groups_1_1 = groups_1.next()) {
                        var group = groups_1_1.value;
                        var _loop_2 = function (variant) {
                            var alreadyThere = (_e = result[size]) === null || _e === void 0 ? void 0 : _e.some(function (v) { return v.id === variant.id; });
                            if (!alreadyThere)
                                (_f = result[size]) === null || _f === void 0 ? void 0 : _f.push(variant);
                        };
                        try {
                            for (var _h = (e_12 = void 0, __values(group.variants)), _j = _h.next(); !_j.done; _j = _h.next()) {
                                var variant = _j.value;
                                _loop_2(variant);
                            }
                        }
                        catch (e_12_1) { e_12 = { error: e_12_1 }; }
                        finally {
                            try {
                                if (_j && !_j.done && (_d = _h.return)) _d.call(_h);
                            }
                            finally { if (e_12) throw e_12.error; }
                        }
                    }
                }
                catch (e_11_1) { e_11 = { error: e_11_1 }; }
                finally {
                    try {
                        if (groups_1_1 && !groups_1_1.done && (_c = groups_1.return)) _c.call(groups_1);
                    }
                    finally { if (e_11) throw e_11.error; }
                }
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (validPatternGroups_2_1 && !validPatternGroups_2_1.done && (_b = validPatternGroups_2.return)) _b.call(validPatternGroups_2);
            }
            finally { if (e_10) throw e_10.error; }
        }
        return result;
    })();
    // Build a "Your Recommendations" category for each size and add the available patterns of the user's preferred pattern gender,
    // if provided, to it.
    var recommendedPatternsPerSize = (function () {
        var e_13, _a, e_14, _b, e_15, _c, _d;
        var result = {};
        try {
            // initialize a category for each size
            for (var _e = __values((0, ts_utils_1.entries)(flatPatternsPerSize)), _f = _e.next(); !_f.done; _f = _e.next()) {
                var _g = __read(_f.value, 1), size = _g[0];
                result[size] = { displayName: 'Your Recommendations', displayType: 'horizontalScroll', variants: [] };
            }
        }
        catch (e_13_1) { e_13 = { error: e_13_1 }; }
        finally {
            try {
                if (_f && !_f.done && (_a = _e.return)) _a.call(_e);
            }
            finally { if (e_13) throw e_13.error; }
        }
        if (!preferredPatternGender)
            return result;
        try {
            for (var _h = __values((0, ts_utils_1.entries)(flatPatternsPerSize)), _j = _h.next(); !_j.done; _j = _h.next()) {
                var _k = __read(_j.value, 2), size = _k[0], patterns = _k[1];
                if (!patterns)
                    throw new Error('Coding bug: patterns is falsy when generating recommendedPatternsPerSize');
                var preferredGenderPatterns = [];
                var genderNeutralPatterns = [];
                try {
                    for (var patterns_1 = (e_15 = void 0, __values(patterns)), patterns_1_1 = patterns_1.next(); !patterns_1_1.done; patterns_1_1 = patterns_1.next()) {
                        var patternVariant = patterns_1_1.value;
                        if (patternVariant.gender === preferredPatternGender) {
                            preferredGenderPatterns.push(patternVariant);
                        }
                        // We decided to put the gender neutral designs in the Your Recommendations category after the preferred
                        // gender design because we felt like there were not enough recommendations in the Your Recommendations category.
                        if (preferredPatternGender !== 'neutral' && patternVariant.gender === 'neutral') {
                            genderNeutralPatterns.push(patternVariant);
                        }
                    }
                }
                catch (e_15_1) { e_15 = { error: e_15_1 }; }
                finally {
                    try {
                        if (patterns_1_1 && !patterns_1_1.done && (_c = patterns_1.return)) _c.call(patterns_1);
                    }
                    finally { if (e_15) throw e_15.error; }
                }
                var category = result[size];
                if (!category)
                    throw new Error('Coding bug: category not initialized when generating selectedPatternsPerSize');
                (_d = category.variants).push.apply(_d, __spreadArray(__spreadArray([], __read(preferredGenderPatterns), false), __read(genderNeutralPatterns), false));
            }
        }
        catch (e_14_1) { e_14 = { error: e_14_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_b = _h.return)) _b.call(_h);
            }
            finally { if (e_14) throw e_14.error; }
        }
        return result;
    })();
    // Build a "Your Selections" category for each size containing the user's selected patterns.
    var selectedPatternsPerSize = buildSelectedPatternsPerSize(flatPatternsPerSize, selectedPatterns);
    var selectedPatternsThisTab = (0, react_1.useMemo)(function () {
        var patterns = selectedPatternsPerSize[tab];
        if (patterns && patterns.patterns.length > 0) {
            // comply with the format that the UI needs to display these
            var patternGroup = { displayName: patterns.displayName, displayType: patterns.displayType, variants: patterns.patterns.map(function (pattern) { return pattern.variant; }) };
            return patternGroup;
        }
        // For this particular memoized variable, we only want to update it when the user comes back to this tab, either from the other tab,
        // or from another bundler step. We do this because we don't want to dynamically create and delete the Your Selections category since
        // doing so would create an annoying UI where the categories are changing and shifting when the user goes from no selections to one
        // selection or vice-a-versa. So we ignore the exhaustive deps rule.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tab]);
    var validPatternGroupsForTab = (function () {
        var result = [];
        if (selectedPatternsThisTab)
            result.push(selectedPatternsThisTab);
        var recommendedPatternsThisTab = recommendedPatternsPerSize[tab];
        if (recommendedPatternsThisTab && recommendedPatternsThisTab.variants.length > 0) {
            result.push(recommendedPatternsThisTab);
        }
        var validGroupsThisTab = validPatternGroups.find(function (group) { return group.size === tab; });
        if (!validGroupsThisTab)
            return []; // this is impossible because tab comes directly from validPatternGroups, but we have to help TypeScript out
        result.push.apply(// this is impossible because tab comes directly from validPatternGroups, but we have to help TypeScript out
        result, __spreadArray([], __read(validGroupsThisTab.groups), false));
        return result;
    })();
    // total number of patterns selected to be checked against total allowed number of patterns
    var selectedPatternQuantity = selectedPatterns.reduce(function (total, pattern) { return total + pattern.quantity; }, 0);
    // navigate between the tabs instead of to next/prev steps
    var beforeGoNext;
    // if this is a multi-size bundle and they're not on the second tab already, take the user to the second tab when they click next
    var shouldGoNextToNextTab = selectedSizes.length > 1 && selectedSizes[1] !== tab;
    if (shouldGoNextToNextTab) {
        beforeGoNext = function () {
            setTab(selectedSizes[1]);
            return false;
        };
    }
    var beforeGoBack;
    var onSecondTab = selectedSizes.length > 1 && selectedSizes[1] === tab;
    if (onSecondTab) {
        beforeGoBack = function () {
            setTab(selectedSizes[0]);
            return false;
        };
    }
    var allPatternIds = selectedPatterns.map(function (pattern) { return pattern.variant.id; });
    // are there either enough patterns to infer a complete bundle or already the right amount of patterns for a complete bundle?
    var atLeastOnePatternPerSizeIsSelected = (function () {
        var e_16, _a, e_17, _b;
        try {
            for (var validPatternGroups_3 = __values(validPatternGroups), validPatternGroups_3_1 = validPatternGroups_3.next(); !validPatternGroups_3_1.done; validPatternGroups_3_1 = validPatternGroups_3.next()) {
                var groups_4 = validPatternGroups_3_1.value.groups;
                var foundAPatternForThisSet = false;
                try {
                    for (var groups_3 = (e_17 = void 0, __values(groups_4)), groups_3_1 = groups_3.next(); !groups_3_1.done; groups_3_1 = groups_3.next()) {
                        var group = groups_3_1.value;
                        if (group.variants.some(function (variant) { return allPatternIds.includes(variant.id); })) {
                            foundAPatternForThisSet = true;
                            continue;
                        }
                    }
                }
                catch (e_17_1) { e_17 = { error: e_17_1 }; }
                finally {
                    try {
                        if (groups_3_1 && !groups_3_1.done && (_b = groups_3.return)) _b.call(groups_3);
                    }
                    finally { if (e_17) throw e_17.error; }
                }
                if (!foundAPatternForThisSet)
                    return false;
            }
        }
        catch (e_16_1) { e_16 = { error: e_16_1 }; }
        finally {
            try {
                if (validPatternGroups_3_1 && !validPatternGroups_3_1.done && (_a = validPatternGroups_3.return)) _a.call(validPatternGroups_3);
            }
            finally { if (e_16) throw e_16.error; }
        }
        return true;
    })();
    // if we're not already using the next button to navigate to the next size tab, and if we don't yet have enough patterns for a complete bundle
    // but we can infer a complete bundle by adding to the patterns that the user has already selected, register that inference to take place
    // when the user proceeds to the next step
    if (!beforeGoNext && atLeastOnePatternPerSizeIsSelected && selectedPatternQuantity !== validPatternQuantity) {
        beforeGoNext = function () {
            // deep clone quantity so that we can modify quantity
            var newPatterns = selectedPatterns.map(function (pattern) { return ({ variant: pattern.variant, quantity: pattern.quantity }); });
            // In the order of the patterns in `selectedPatterns`, add the the quantities until we can make a complete bundle,
            // then update the selected patterns in the store accordingly. The order matters in the case where we cannot distribute
            // our additions over the selected patterns evenly.
            for (var i = 0; i < validPatternQuantity - selectedPatternQuantity; i++) {
                var patternToIncrement = newPatterns[i % selectedPatterns.length];
                patternToIncrement.quantity += 1;
            }
            changePatterns(newPatterns);
            return true;
        };
    }
    var nextButtonEnabled = (function () {
        // have to let the user click the next button if we want to take them to the next tab when they click it
        if (shouldGoNextToNextTab)
            return true;
        // otherwise assess if we have at least one pattern for each size, in which case we will just add more quantity to those patterns
        return atLeastOnePatternPerSizeIsSelected;
    })();
    // build display information for progress bar and tabs
    var progressBarValues = [];
    var groups = Object.values(selectedPatternsPerSize);
    var colors = ['#E2F2F8', '#F5E2FE'];
    try {
        for (var _e = __values(groups.entries()), _f = _e.next(); !_f.done; _f = _e.next()) {
            var _g = __read(_f.value, 2), i = _g[0], group = _g[1];
            var quantityChosenForThisTab = group.patterns.reduce(function (total, pattern) { return total + pattern.quantity; }, 0);
            progressBarValues.push({ value: quantityChosenForThisTab, color: colors[i % colors.length] });
        }
    }
    catch (e_7_1) { e_7 = { error: e_7_1 }; }
    finally {
        try {
            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
        }
        finally { if (e_7) throw e_7.error; }
    }
    var tabs = [];
    try {
        for (var _h = __values(selectedSizes.entries()), _j = _h.next(); !_j.done; _j = _h.next()) {
            var _k = __read(_j.value, 2), i = _k[0], size = _k[1];
            tabs.push({ size: size, color: colors[i] });
        }
    }
    catch (e_8_1) { e_8 = { error: e_8_1 }; }
    finally {
        try {
            if (_j && !_j.done && (_c = _h.return)) _c.call(_h);
        }
        finally { if (e_8) throw e_8.error; }
    }
    var productCardWidth = 128;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: 'h-8' }),
        react_1.default.createElement("div", { className: 'padding-horizontal-6 space-y-2' },
            react_1.default.createElement("div", { className: 'flex-container align-justify' },
                react_1.default.createElement("div", { className: 'text-2xl', style: { fontWeight: 600 } }, patternStepHeader ? patternStepHeader : 'Select Your Designs')),
            react_1.default.createElement("div", { className: 'flex-container align-justify' },
                react_1.default.createElement("div", { className: 'text-almost-black' },
                    "Pick up to ",
                    validPatternQuantity,
                    " options of our super-cute diaper styles! All designs are subject to availability.",
                    selectedSizes.some(bundle_1.isDiaperSize) && ' Please note: wetness indicator is only available on sizes N-2.'))),
        react_1.default.createElement("div", { className: 'bundler-v2-patterns--sticky-top-section z15 bg-white' },
            react_1.default.createElement("div", { className: 'h-4' }),
            react_1.default.createElement("div", { className: 'padding-horizontal-6 flex-container align-justify align-middle space-x-4 margin-horizontal-auto', style: { maxWidth: 450 } },
                react_1.default.createElement("div", { className: 'h-3', style: { flex: 1 } },
                    react_1.default.createElement(progress_bar_1.default, { values: progressBarValues, outOf: validPatternQuantity, outerStyle: { borderWidth: 1, borderStyle: 'solid' } })),
                react_1.default.createElement("div", { className: 'text-xs', style: { fontFamily: 'sans-serif' } },
                    selectedPatternQuantity,
                    " of ",
                    validPatternQuantity)),
            selectedSizes.length > 1 && (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement("div", { className: 'h-4' }),
                react_1.default.createElement("div", { className: 'padding-horizontal-6 margin-horizontal-auto', style: { maxWidth: 450 } },
                    react_1.default.createElement("div", { className: 'flex-container rounded-base', style: { borderStyle: 'solid', borderWidth: 1 } },
                        react_1.default.createElement(SizeTabs, { tabs: tabs, tab: tab, setTabSize: setTab }))))),
            react_1.default.createElement("div", { className: 'h-4' }),
            react_1.default.createElement("div", { className: 'margin-horizontal-6 border-very-light-pink', style: { borderTopWidth: 1, borderTopStyle: 'solid' } })),
        react_1.default.createElement("div", { className: 'h-4' }),
        react_1.default.createElement("div", { className: 'padding-left-6' },
            react_1.default.createElement("div", { className: 'space-y-4' }, validPatternGroupsForTab.length > 0 ? (validPatternGroupsForTab.map(function (group) { return (react_1.default.createElement("div", { key: group.displayName },
                react_1.default.createElement("div", { className: 'text-xl' }, group.displayName),
                react_1.default.createElement("div", { className: 'h-2' }),
                group.displayType === 'horizontalScroll' ? (react_1.default.createElement(horizontal_drag_scroll_1.default, { className: 'horizontal-drag-scroll--container padding-right-6 space-x-4 hide-scrollbar cursor-grab-grabbing' }, group.variants.map(function (variant) {
                    var pattern = selectedPatterns.find(function (p) { return p.variant.id === variant.id; });
                    return (react_1.default.createElement(ProductCard, { key: variant.id, className: 'horizontal-drag-scroll--item', width: productCardWidth, item: { variant: variant }, selected: !!pattern, quantity: (pattern === null || pattern === void 0 ? void 0 : pattern.quantity) || 0, onIncrement: function () { return onIncrementPatternQuantity(variant, selectedPatterns, changePatterns, flatPatternsPerSize, tab, validPatternQuantity, selectedSizes); }, onDecrement: function () { return onDecrementPatternQuantity(variant, selectedPatterns, changePatterns); } }));
                }))) : (react_1.default.createElement("div", { className: 'bundler-v2-index--product-card-grid padding-right-6' }, group.variants.map(function (variant) {
                    var pattern = selectedPatterns.find(function (p) { return p.variant.id === variant.id; });
                    return (react_1.default.createElement(ProductCard, { key: variant.id, imageContainerClassName: 'cursor-pointer', item: { variant: variant }, selected: !!pattern, quantity: (pattern === null || pattern === void 0 ? void 0 : pattern.quantity) || 0, onIncrement: function () { return onIncrementPatternQuantity(variant, selectedPatterns, changePatterns, flatPatternsPerSize, tab, validPatternQuantity, selectedSizes); }, onDecrement: function () { return onDecrementPatternQuantity(variant, selectedPatterns, changePatterns); } }));
                }))))); })) : (react_1.default.createElement("div", { className: 'text-center bg-almost-white padding-10 padding-vertical-15 margin-right-6' },
                react_1.default.createElement("div", { className: 'text-lg' }, "Whoops, Sorry!"),
                react_1.default.createElement("div", { className: 'divider bg-light-wisteria margin-vertical-3 margin-horizontal-auto' }),
                react_1.default.createElement("div", { className: 'text-base' }, "We\u2019re currently all out of booty wrappers in that size. If your kiddo\u2019s near sizing up, click back and choose a new size."))))),
        navBar({ backButtonEnabled: true, nextButtonEnabled: nextButtonEnabled, beforeGoNext: beforeGoNext, beforeGoBack: beforeGoBack })));
};
exports.default = Patterns;
